export default "__VITE_ASSET__DtfQYTYZ__"